import ReactModal from 'react-modal';
import React from 'react';
import styles from '../../../components/browser-modal/browser-modal.css';
import customStyles from './confirm-modal.css';
import Box from '../../../components/box/box.jsx';

import { render } from '../../guide/highlight.jsx';
import event, { EVENTS } from '../../lib/event';
import Audio from '../../lib/audio';
import closeImg from './poopup_btn_icon_close.png';

class ConfirmModal extends React.Component {
    constructor(props) {
        super(props);
        this.close = this.close.bind(this);
        this.state = {
            isOpen: true,
            type: 'onClose'
        };
        this.modalRef = React.createRef();
        event.once(EVENTS.STEP_ABORT, this.close);
    }

    close() {
        this.setState({ ...this.state, isOpen: false });
    }
    componentDidMount() {
        // Audio.play(`${window.config.staticURL}/audio/pop.mp3`);
    }
    componentWillUnmount() {
        this.isUnmounted = true;
        event.removeListener(EVENTS.STEP_ABORT, this.close);
    }

    render() {
        const { onClose, title, msg, onConfirm, onConfirm2, closed = false, confirmText = '确定', confirmText2, closeText = '取消' } = this.props;
        const that = this;
        return (
            <ReactModal
                ref={this.modalRef}
                isOpen={this.state.isOpen}
                className={`${styles.modalContent} ${customStyles.madalBox}`}
                overlayClassName={`${styles.modalOverlay} ${customStyles.bg}`}
                closeTimeoutMS={400}
                onAfterClose={() => {
                    if (that.isUnmounted) return;
                    event.emit(EVENTS.CLEAR_COVER);

                    /*
                    const modalEl = document.querySelector('.ReactModalPortal');
                    if (modalEl) {
                        document.body.removeChild(modalEl);
                    }

                    if (this.modalRef.current) {
                        this.modalRef.current.node.remove();
                    }
                     */
                    switch (this.state.type) {
                        case 'onClose':
                            onClose();
                            break;
                        case 'onConfirm':
                            onConfirm();
                            break;
                        case 'onConfirm2':
                            onConfirm2();
                            break;
                    }
                }}
            >
                <div>
                    <Box className={`${styles.illustration} ${customStyles.title}`}>
                        提示
                        {closed ? (
                            <a
                                onClick={() => {
                                    // Audio.play(`${window.config.staticURL}/audio/cancle.mp3`);
                                    this.setState({
                                        isOpen: false,
                                        type: 'onClose'
                                    });
                                }}
                            >
                                <img src={closeImg} />关闭
                            </a>
                        ) : ('')}
                    </Box>

                    <Box className={styles.body}>
                        <h4>
                            {title || '温馨提示'}
                        </h4>
                        <p>
                            {msg}
                        </p>

                        <Box className={`${styles.buttonRow} ${customStyles.buttonBox}`}>
                            {onClose &&
                                <button
                                    onClick={() => {
                                        Audio.play(`${window.config.staticURL}/audio/cancle.mp3`);
                                        this.setState({
                                            isOpen: false,
                                            type: 'onClose'
                                        });
                                    }}
                                >
                                    {closeText}
                                </button>
                            }
                            <button
                                style={{ backgroundColor: '#FFB41F', border: '1px solid #FFB41F' }}
                                onClick={() => {
                                    Audio.play(`${window.config.staticURL}/audio/confirm.mp3`);
                                    this.setState({
                                        isOpen: false,
                                        type: 'onConfirm'
                                    });
                                }}
                            >
                                {confirmText}
                            </button>
                            {onConfirm2 &&
                                <button
                                    style={{ backgroundColor: '#FFB41F', border: '1px solid #FFB41F' }}
                                    onClick={() => {
                                        Audio.play(`${window.config.staticURL}/audio/confirm.mp3`);
                                        this.setState({
                                            isOpen: false,
                                            type: 'onConfirm2'
                                        });
                                    }}
                                >
                                    {confirmText2}
                                </button>
                            }
                        </Box>
                    </Box>
                </div>
            </ReactModal>
        );
    }
}

const renderConfirmModal = (props) => {
    render(
        <ConfirmModal
            {...props}
        />
    );
};


export {
    renderConfirmModal
};
